export const copayMaxRequestLimit = 20;